import React from "react";
import { Cell } from "@sonder/ui/source/styled/fragments/Table";
import { useLayout } from "core/components/LayoutProvider";
import { SortableCell } from "tasks/components/TaskList/SortableCell";
import { TaskSortColumn } from "typings/globalGQLTypes";

interface HeaderRowProps {
  title: string;
  checkbox: React.ReactNode;
}

export const HeaderRow = ({ title, checkbox }: HeaderRowProps) => {
  const { sidepanel } = useLayout();
  return (
    <>
      <Cell rowStart>{checkbox}</Cell>
      <Cell />
      <SortableCell sortKey={TaskSortColumn.name}>{title}</SortableCell>
      <SortableCell sortKey={TaskSortColumn.priority}>Priority</SortableCell>
      <SortableCell sortKey={TaskSortColumn.internal_ref}>
        Location
      </SortableCell>
      <SortableCell sortKey={TaskSortColumn.assignee_id}>
        Assignee(s)
      </SortableCell>
      <SortableCell sortKey={TaskSortColumn.due_at}>Due By</SortableCell>
      <Cell>Turnover</Cell>
      {sidepanel === "collapsed" && (
        <>
          <SortableCell sortKey={TaskSortColumn.status}>Status</SortableCell>
          <Cell />
        </>
      )}
      <Cell rowEnd />
    </>
  );
};
